import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createOrganisationsSchemas } from 'shared/db/validation/schema/organisations';
import { Validator } from 'shared/db/validation/validator';
import {
    OrganisationRawRecord,
    OrganisationUpdateRawRecord,
} from 'shared/types/Organisation';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { OrganisationsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createOrganisationsSchemas();

const addValidator = createDBEntityValidator<OrganisationRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<OrganisationUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-organisations'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createOrganisationsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const organisationsInputValidation: OrganisationsDBValidation = {
    add: createOrganisationsInputValidation(addValidator, validationStrategy),
    update: createOrganisationsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createOrganisationsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
